@if (allowedFileExtensions) {
    <div
        class="detail-page-card"
        [class.m-0]="noMargin"
        [class.compact-document-manager-old]="compactMode"
        fileDrop
        (fileDrop)="fileDropHandler($event)"
        [fullScreenDropArea]="fullScreenDropArea"
        [allowedExtensions]="allowedFileExtensions"
        [allowDrop]="permissions.canAddDocument"
    >
        <div class="document-title-row">
            @let labelText = Label ?? ("documentsLabel" | t);
            @if (!hideLabel && labelText) {
                <div class="detail-page-card-title">{{ labelText }}</div>
                @if (Tooltip) {
                    <i class="far fa-info-circle mx-2" [matTooltip]="Tooltip"> </i>
                }
            }
        </div>

        @if (!hideAddButton) {
            <div class="detail-page-card-actions">
                <button
                    data-uiid="documentmanager-adddocument"
                    class="btn btn-raised"
                    (click)="openEdit()"
                    [disabled]="disabled || !permissions.canAddDocument"
                >
                    <i class="fas fa-plus-circle"></i>
                    <span>{{ "addDocument" | t }}</span>
                </button>
            </div>
        }
        <div
            class="detail-page-card-body flush-expansion-panels"
            [style.max-height]="MaxHeight ? MaxHeight : ''"
            [class.scrollable]="scrollEnabled"
        >
            @if (!ShowSummary) {
                <span>
                    <mat-accordion>
                        @for (doc of Documents | sortby: "Date" : "desc"; track doc) {
                            <mat-expansion-panel
                                [attr.data-uiid]="'documentmanager-document-row-' + doc.Guid"
                                [ngClass]="{ deleted: doc.Deleted }"
                            >
                                <mat-expansion-panel-header
                                    [collapsedHeight]="headerHeight"
                                    [expandedHeight]="headerHeight"
                                >
                                    <mat-panel-title
                                        [class.col-md-8]="!compactMode"
                                        [class.col-md-12]="compactMode"
                                        [matTooltip]="doc.Name"
                                    >
                                        @if (!doc.IsNew && !doc.Edited && !doc.Deleted) {
                                            <i
                                                [attr.data-uiid]="
                                                    'documentmanager-document-status-current-' +
                                                    doc.Guid
                                                "
                                                class="fas fa-{{ doc.FileIcon }}"
                                            ></i>
                                        }
                                        @if (doc.IsNew) {
                                            <i
                                                [attr.data-uiid]="
                                                    'documentmanager-document-status-new-' +
                                                    doc.Guid
                                                "
                                                class="fas fa-plus"
                                            ></i>
                                        }
                                        @if (doc.Edited) {
                                            <i
                                                [attr.data-uiid]="
                                                    'documentmanager-document-status-edited-' +
                                                    doc.Guid
                                                "
                                                class="fas fa-pencil"
                                            ></i>
                                        }
                                        @if (doc.Deleted) {
                                            <i
                                                [attr.data-uiid]="
                                                    'documentmanager-document-status-deleted-' +
                                                    doc.Guid
                                                "
                                                class="fas fa-times"
                                            ></i>
                                        }
                                        <span
                                            [attr.data-uiid]="
                                                'documentmanager-document-name-' + doc.Guid
                                            "
                                            [attr.data-deleted]="!!doc.Deleted"
                                            class="document-name text-truncate ms-2"
                                            >{{ doc.Name }}
                                            @if (doc.Changed) {
                                                <i
                                                    [attr.data-uiid]="
                                                        'documentmanager-document-edited-' +
                                                        doc.Guid
                                                    "
                                                    >{{
                                                        "editedMarker"
                                                            | t
                                                    }}</i
                                                >
                                            }
                                        </span>
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        @if (!doc.Deleted && AllowEdit) {
                                            <i
                                                [attr.data-uiid]="
                                                    'documentmanager-document-edit-' + doc.Guid
                                                "
                                                class="fas fa-pencil-alt"
                                                (click)="openEdit(doc); $event.stopPropagation()"
                                            ></i>
                                        }
                                        @if (!doc.IsNew) {
                                            <a
                                                [attr.data-uiid]="
                                                    'documentmanager-document-download-' + doc.Guid
                                                "
                                                class="fas fa-download"
                                                [href]="
                                                    'api/documents/manager/' + doc.Guid + '/data'
                                                "
                                                target="_blank"
                                            ></a>
                                        }
                                        @if (!disabled && doc.CanDelete) {
                                            <i
                                                [attr.data-uiid]="
                                                    'documentmanager-document-delete-' + doc.Guid
                                                "
                                                class="fas fa-{{ doc.Deleted ? 'undo' : 'trash' }}"
                                                (click)="
                                                    toggleDelete(doc); $event.stopPropagation()
                                                "
                                            ></i>
                                        }
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th>
                                                {{ "userHeader" | t }}
                                            </th>
                                            <td>{{ doc.Username }}</td>
                                        </tr>
                                        <tr>
                                            <th>
                                                {{ "dateHeader" | t }}
                                            </th>
                                            <td>{{ doc.Date | dateTimeFormat }}</td>
                                        </tr>
                                        <tr>
                                            <th>
                                                {{
                                                    "versionsHeader" | t
                                                }}
                                            </th>
                                            <td>{{ doc.Version }}</td>
                                        </tr>
                                        @if (ShowType) {
                                            <tr>
                                                <th>
                                                    {{
                                                        "typeHeader" | t
                                                    }}
                                                </th>
                                                <td>{{ doc.DocumentType }}</td>
                                            </tr>
                                        }
                                        <tr>
                                            <th>
                                                {{
                                                    "descriptionHeader"
                                                        | t
                                                }}
                                            </th>
                                            <td title="{{ doc.Description }}">
                                                {{ doc.Description }}
                                            </td>
                                        </tr>
                                        @if (!doc.IsNew && doc.Name.endsWith(".pdf")) {
                                            <tr>
                                                <th>
                                                    {{
                                                        "pdfViewerHeader"
                                                            | t
                                                    }}
                                                </th>
                                                <td
                                                    (click)="openDocumentViewer(doc)"
                                                    style="color: blue; cursor: pointer"
                                                >
                                                    {{
                                                        "openPdfViewer"
                                                            | t
                                                    }}
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </mat-expansion-panel>
                        }
                    </mat-accordion>
                </span>
            }
            @if (!disabled && (!Documents || Documents.length === 0)) {
                <div class="drop-zone p-2">
                    <span>{{
                        permissions.canAddDocument
                            ? (NoDocumentMessage ??
                              ("noDocumentMessage" | t))
                            : ("noDocumentsUploaded" | t)
                    }}</span>
                </div>
            }
            @if (ShowSummary) {
                <div class="documents-col">
                    @if (Documents?.length > 0) {
                        <span>
                            {{
                                "documentCount"
                                    | t: { count: Documents.length }
                            }}
                        </span>
                    }
                </div>
            }
        </div>
    </div>
}
